import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from '../services/auth-service/auth.service';

/**
 * Prevents unauthorized users from activating or loading protected paths and forces unauthenticated users into the authentication flow
 */
@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanLoad, CanActivate, CanActivateChild {
  private readonly authPath = '/auth';
  private readonly defaultUrlFragments = [''];
  private readonly authUrlFragments = ['auth'];

  constructor(private authService: AuthService, private router: Router) {}

  canLoad(route: Route): boolean | UrlTree {
    return this.isAuthorized(route.path ?? '');
  }

  canActivateChild(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.isAuthorized(state.url);
  }

  canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    return this.isAuthorized(state.url);
  }

  /**
   * Determine, depending on the requested path and authentication status, whether to allow navigation or to redirect
   *
   * @param path the plain text path of the requested route
   */
  private isAuthorized(path: string): boolean | UrlTree {
    // if user is requesting the auth component
    const loggedIn = this.authService.hasValidAccessToken();
    if (path.startsWith(this.authPath)) {
      return loggedIn ? this.router.createUrlTree(['/']) : true; // stay on auth page
    }

    if (!loggedIn) {
      // Remember the payment path for after logi
      if (!sessionStorage.getItem('post_login_redirect_uri')) {
        sessionStorage.setItem('post_login_redirect_uri', path);
      }
      return this.router.createUrlTree([this.authPath]);
    }
    return true;
  }
}
